"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4648],{

/***/ 52479:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ AtomicComponents_Button; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(50066);
// EXTERNAL MODULE: ./src/components/DesignSystem/AtomicComponents/util.js
var util = __webpack_require__(52388);
;// CONCATENATED MODULE: ./src/components/DesignSystem/AtomicComponents/Button/Button.styles.js

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  cursor: pointer;\n  text-align: center;\n  outline: none;\n  border-width: ",
        ";\n  border-style: solid;\n  letter-spacing: 0.3px;\n  text-transform: ",
        ";\n  width: ",
        ";\n  ",
        ";\n  font-weight: ",
        ";\n  font-size: ",
        "px;\n  display: ",
        ";\n  ",
        ";\n  ",
        ";\n  ",
        ";\n  ",
        ";\n  ",
        ";\n  ",
        ";\n  ",
        ";\n  ",
        ";\n  ",
        ";\n  ",
        ";\n  ",
        ";\n  ",
        ";\n  ",
        ";\n  background-color: ",
        ";\n  border-radius: ",
        ";\n  color: ",
        ";\n  box-shadow: ",
        ";\n  border-color: ",
        ";\n  border-color: ",
        ";\n  ",
        ";\n  &:hover {\n    background-color: ",
        ";\n  }\n  ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var ButtonBody = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    displayName: "ButtonBody",
    componentId: "sc-989935d2-0"
})(_templateObject(), function(props) {
    return props.borderWidth || "1px";
}, function(props) {
    return props.textTransform;
}, function(props) {
    return props.fluid ? "100%" : "fit-content";
}, function(props) {
    return (props === null || props === void 0 ? void 0 : props.width) && "width : ".concat(props === null || props === void 0 ? void 0 : props.width);
}, function(props) {
    return props.fontWeight || 500;
}, function(props) {
    return props.fontSize || 14;
}, function(props) {
    return props.display || "block";
}, function(props) {
    return props.pt && "padding-top: ".concat(props.pt);
}, function(props) {
    return props.pb && "padding-bottom: ".concat(props.pb);
}, function(props) {
    return props.pl && "padding-left: ".concat(props.pl);
}, function(props) {
    return props.pr && "padding-right: ".concat(props.pr);
}, function(props) {
    return props.px && "\n      padding-left: ".concat(props.px, ";\n      padding-right: ").concat(props.px, ";\n    ");
}, function(props) {
    return props.py && "\n      padding-top: ".concat(props.py, ";\n      padding-bottom: ").concat(props.py, ";\n    ");
}, function(props) {
    return props.mt && "margin-top: ".concat(props.mt);
}, function(props) {
    return props.mb && "margin-bottom: ".concat(props.mb);
}, function(props) {
    return props.ml && "margin-left: ".concat(props.ml);
}, function(props) {
    return props.mr && "margin-right: ".concat(props.mr);
}, function(props) {
    return props.mx && "\n      margin-left: ".concat(props.mx, ";\n      margin-right: ").concat(props.mx, ";\n    ");
}, function(props) {
    return props.my && "\n      margin-top: ".concat(props.my).concat(props.my !== "auto" && "", ";\n      margin-bottom: ").concat(props.my).concat(props.my !== "auto" && "", ";\n    ");
}, function(props) {
    return props.maxWidth && "max-width: ".concat(props.maxWidth);
}, function(props) {
    return props.variant === "outline" ? "transparent" : props.backgroundColor || "#000000";
}, function(props) {
    return (0,util/* roundnessCalculator */.M)(props.roundness);
}, function(props) {
    return props.variant === "outline" ? props.backgroundColor : props.fontColor || "#ffffff";
}, function(props) {
    return !props.disabled && props.boxShadow;
}, function(props) {
    return props.backgroundColor;
}, function(props) {
    return props.borderColor;
}, function(props) {
    return (props === null || props === void 0 ? void 0 : props.whiteSpace) && "white-space: ".concat(props === null || props === void 0 ? void 0 : props.whiteSpace);
}, function(props) {
    return props.hoverEnabled && "#F8F8F8";
}, function(props) {
    return props.isDisable && "opacity: 0.5";
});

// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
;// CONCATENATED MODULE: ./src/components/DesignSystem/AtomicComponents/Button/index.js







var Button = function(props) {
    var label = props.label, args = (0,_object_without_properties/* default */.Z)(props, [
        "label"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonBody, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, args), {
        children: label
    }));
};
Button.propsTypes = {
    backgroundColor: (prop_types_default()).string,
    label: (prop_types_default()).string.isRequired,
    onClick: (prop_types_default()).any,
    display: (prop_types_default()).string,
    roundness: (prop_types_default()).number,
    width: (prop_types_default()).string,
    textTransform: (prop_types_default()).string,
    fontColor: (prop_types_default()).string,
    pt: (prop_types_default()).string,
    pl: (prop_types_default()).string,
    pb: (prop_types_default()).string,
    pr: (prop_types_default()).string,
    py: (prop_types_default()).string,
    px: (prop_types_default()).string,
    mt: (prop_types_default()).string,
    mb: (prop_types_default()).string,
    ml: (prop_types_default()).string,
    mr: (prop_types_default()).string,
    mx: (prop_types_default()).string,
    my: (prop_types_default()).string,
    fluid: (prop_types_default()).bool,
    borderColor: (prop_types_default()).string,
    disabled: (prop_types_default()).bool,
    fontSize: (prop_types_default()).number,
    variant: (prop_types_default()).string,
    whiteSpace: (prop_types_default()).string
};
/* harmony default export */ var AtomicComponents_Button = (Button);


/***/ }),

/***/ 38855:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "zx": function() { return /* reexport */ Button/* default */.Z; },
  "WE": function() { return /* reexport */ CartButton/* default */.Z; },
  "rs": function() { return /* reexport */ AtomicComponents_Switch; }
});

// EXTERNAL MODULE: ./src/components/DesignSystem/AtomicComponents/Button/index.js + 1 modules
var Button = __webpack_require__(52479);
// EXTERNAL MODULE: ./src/components/DesignSystem/AtomicComponents/CartButton/index.js
var CartButton = __webpack_require__(8673);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(50066);
// EXTERNAL MODULE: ./src/components/DesignSystem/AtomicComponents/util.js
var util = __webpack_require__(52388);
;// CONCATENATED MODULE: ./src/components/DesignSystem/AtomicComponents/Switch/Switch.styles.js

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex: 0;\n  width: fit-content;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n  cursor: pointer;\n  box-sizing: border-box;\n  outline: none;\n  width: ",
        ";\n  outline: none;\n  background-color: #eeeef1;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: ",
        "px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  box-sizing: border-box;\n  display: flex;\n  width: fit-content;\n  align-items: center;\n  justify-content: center;\n  padding: 8px 12px;\n\n  color: #646464;\n\n  width: ",
        ";\n  width: ",
        ";\n\n  @media screen and (min-width: 767px) {\n    width: 100px;\n    font-size: 16px;\n  }\n\n  @media screen and (max-width: 766px) {\n    width: 80px;\n    font-size: 14px;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  box-sizing: border-box;\n  position: absolute;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  top: 50%;\n  background: ",
        ";\n  color: ",
        ";\n  transform: translateY(-50%);\n  height: calc(100% + 6px);\n  border-radius: ",
        ";\n  width: 50%;\n  ",
        "\n\n  @media screen and (min-width: 767px) {\n    font-size: 16px;\n  }\n\n  @media screen and (max-width: 766px) {\n    font-size: 14px;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  box-sizing: border-box;\n  display: flex;\n  position: relative;\n  align-items: center;\n  justify-content: center;\n  top: 50%;\n  background: ",
        ";\n  color: ",
        ";\n  height: calc(100% + 6px);\n  border-radius: ",
        ";\n  width: 100%;\n  padding: 8px 12px;\n\n  border-top-left-radius: ",
        ";\n  border-bottom-left-radius: ",
        ";\n  border-top-right-radius: ",
        ";\n  border-bottom-right-radius: ",
        ";\n\n  @media screen and (min-width: 767px) {\n    font-size: 16px;\n  }\n\n  @media screen and (max-width: 766px) {\n    font-size: 14px;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}


var SwitchContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "SwitchContainer",
    componentId: "sc-3f72cec7-0"
})(_templateObject(), function(props) {
    return props.fluid ? "100%" : "fit-content";
});
var switches = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "switches",
    componentId: "sc-3f72cec7-1"
})(_templateObject1(), function(props) {
    return props.fontSize || 14;
});
var SwitchLabel = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "SwitchLabel",
    componentId: "sc-3f72cec7-2"
})(_templateObject2(), function(props) {
    return props.width && "".concat(props.width, " !important;");
}, function(props) {
    return props.fluid && "100% !important;";
});
var SwitchToggle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "SwitchToggle",
    componentId: "sc-3f72cec7-3"
})(_templateObject3(), function(props) {
    return props.backgroundColor || "#6E25F8";
}, function(props) {
    return props.fontColor || "#ffffff";
}, function(props) {
    return (0,util/* roundnessCalculator */.M)(props.roundness);
}, function(props) {
    return !!props.isToggle ? "right: -5px;" : "left: -5px;";
});
var Toggle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "Toggle",
    componentId: "sc-3f72cec7-4"
})(_templateObject4(), function(props) {
    return props.backgroundColor || "#6E25F8";
}, function(props) {
    return props.fontColor || "#ffffff";
}, function(props) {
    return (0,util/* roundnessCalculator */.M)(props.roundness * 2);
}, function(props) {
    return (0,util/* roundnessCalculator */.M)(props.roundness);
}, function(props) {
    return (0,util/* roundnessCalculator */.M)(props.roundness);
}, function(props) {
    return (0,util/* roundnessCalculator */.M)(props.roundness);
}, function(props) {
    return (0,util/* roundnessCalculator */.M)(props.roundness);
});

// EXTERNAL MODULE: ./src/containers/Orders/context/index.tsx
var context = __webpack_require__(60227);
;// CONCATENATED MODULE: ./src/components/DesignSystem/AtomicComponents/Switch/index.js





var Switch = function(props) {
    var ref = (0,react.useContext)(context/* OrderContext */.y), onChangeActiveTab = ref.onChangeActiveTab, activeTab = ref.activeTab;
    var _tabsData = props.tabsData, tabsData = _tabsData === void 0 ? [] : _tabsData, _roundness = props.roundness, roundness = _roundness === void 0 ? 2 : _roundness, _fluid = props.fluid, fluid = _fluid === void 0 ? false : _fluid, backgroundColor = props.backgroundColor, width = props.width;
    var tabRoundness = (0,util/* roundnessCalculator */.M)(roundness) || "0px";
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SwitchContainer, {
        backgroundColor: backgroundColor,
        fluid: fluid,
        fontSize: 14,
        className: "tw-h-[48px]",
        style: {
            borderRadius: tabRoundness
        },
        children: tabsData.map(function(param) {
            var text = param.text, key = param.key;
            var isActiveTab = activeTab === key;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(SwitchLabel, {
                fluid: fluid,
                width: width,
                onClick: function() {
                    return onChangeActiveTab(key);
                },
                isActiveTab: isActiveTab,
                className: "tw-relative tw-h-full tw-w-full tw-bg-transparent",
                style: {
                    borderRadius: tabRoundness
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: isActiveTab ? "tw-absolute -tw-inset-x-[5px] -tw-inset-y-[2px] tw-z-10 tw-flex tw-items-center tw-justify-center tw-text-white" : "",
                    style: {
                        backgroundColor: isActiveTab ? backgroundColor : "transparent",
                        borderRadius: tabRoundness
                    },
                    children: text
                })
            }, key);
        })
    });
};
/* harmony default export */ var AtomicComponents_Switch = (Switch);

;// CONCATENATED MODULE: ./src/components/DesignSystem/AtomicComponents/index.js






/***/ }),

/***/ 19976:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _utils_constant__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(42194);



var ReadMoreReadLess = function(param) {
    var text = param.text, color = param.color, maxChar = param.maxChar;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(true), isReadMore = ref[0], setIsReadMore = ref[1];
    var toggleReadMore = function() {
        return setIsReadMore(!isReadMore);
    };
    var isLongText = (text === null || text === void 0 ? void 0 : text.length) > (maxChar !== null && maxChar !== void 0 ? maxChar : _utils_constant__WEBPACK_IMPORTED_MODULE_2__/* .READ_MORE_TEXT_LIMIT */ .d);
    var displayedText = isReadMore && isLongText ? "".concat(text === null || text === void 0 ? void 0 : text.substring(0, maxChar || _utils_constant__WEBPACK_IMPORTED_MODULE_2__/* .READ_MORE_TEXT_LIMIT */ .d), "...") : text;
    var toggleText = isReadMore ? "Read More" : "Read Less";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
        className: "tw-break-all tw-text-[0.75rem] tw-font-normal tw-leading-4 md:tw-text-[0.875rem] tw-text-[".concat(color, "] ").concat(maxChar ? "md:tw-text-[12px]" : "md:tw-text-[0.875rem]"),
        children: [
            displayedText,
            isLongText && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                onClick: toggleReadMore,
                className: "tw-cursor-pointer tw-text-[0.75rem] tw-font-medium tw-text-[#0E0E0E] tw-underline md:tw-text-[0.875rem] ".concat(isReadMore ? "" : "tw-pl-[6px]"),
                children: toggleText
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ReadMoreReadLess);


/***/ }),

/***/ 24648:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "X": function() { return /* binding */ ProductCustomizationPopUp; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 18 modules
var es = __webpack_require__(25617);
// EXTERNAL MODULE: ./src/components/Common/Modal/index.jsx
var Modal = __webpack_require__(72651);
;// CONCATENATED MODULE: ./src/components/ProductCustomizationPopUp/utils/SvgExport.js

var PlusIcon = function(param) {
    var color = param.color;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                "clip-path": "url(#clip0_115_1132)",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M19 13H13V19H11V13H5V11H11V5H13V11H19V13Z",
                    fill: color || "#2F80ED"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_115_1132",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "24",
                        height: "24",
                        fill: "white"
                    })
                })
            })
        ]
    });
};
var CancelIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                "clip-path": "url(#clip0_115_1154)",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M14.59 8L12 10.59L9.41 8L8 9.41L10.59 12L8 14.59L9.41 16L12 13.41L14.59 16L16 14.59L13.41 12L16 9.41L14.59 8ZM12 2C6.47 2 2 6.47 2 12C2 17.53 6.47 22 12 22C17.53 22 22 17.53 22 12C22 6.47 17.53 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20Z",
                    fill: "#0E0E0E"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_115_1154",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "24",
                        height: "24",
                        fill: "white"
                    })
                })
            })
        ]
    });
};
var ErrorIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                "clip-path": "url(#clip0_117_1656)",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M9.16675 12.4998H10.8334V14.1665H9.16675V12.4998ZM9.16675 5.83317H10.8334V10.8332H9.16675V5.83317ZM9.99175 1.6665C5.39175 1.6665 1.66675 5.39984 1.66675 9.99984C1.66675 14.5998 5.39175 18.3332 9.99175 18.3332C14.6001 18.3332 18.3334 14.5998 18.3334 9.99984C18.3334 5.39984 14.6001 1.6665 9.99175 1.6665ZM10.0001 16.6665C6.31675 16.6665 3.33341 13.6832 3.33341 9.99984C3.33341 6.3165 6.31675 3.33317 10.0001 3.33317C13.6834 3.33317 16.6667 6.3165 16.6667 9.99984C16.6667 13.6832 13.6834 16.6665 10.0001 16.6665Z",
                    fill: "#9A0C00"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_117_1656",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "20",
                        height: "20",
                        fill: "white"
                    })
                })
            })
        ]
    });
};
var RemoveIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M4.26667 12.6668L3.33333 11.7335L7.06667 8.00016L3.33333 4.26683L4.26667 3.3335L8 7.06683L11.7333 3.3335L12.6667 4.26683L8.93333 8.00016L12.6667 11.7335L11.7333 12.6668L8 8.9335L4.26667 12.6668Z",
            fill: "#E8EAED"
        })
    });
};
var CartPlusIcon = function(param) {
    var _color = param.color, color = _color === void 0 ? "#0E0E0E" : _color;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "16",
        height: "17",
        viewBox: "0 0 16 17",
        fill: "none",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                "clip-path": "url(#clip0_286_2302)",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M12.6666 9.16683H8.66659V13.1668H7.33325V9.16683H3.33325V7.8335H7.33325V3.8335H8.66659V7.8335H12.6666V9.16683Z",
                    fill: color
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_286_2302",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "16",
                        height: "16",
                        fill: "white",
                        transform: "translate(0 0.5)"
                    })
                })
            })
        ]
    });
};
var CartMinusIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "16",
        height: "17",
        viewBox: "0 0 16 17",
        fill: "none",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M3.33325 9.16683V7.8335H12.6666V9.16683H3.33325Z",
            fill: "#0E0E0E"
        })
    });
};
var RightArrowIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "20",
        height: "21",
        viewBox: "0 0 20 21",
        fill: "none",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                "clip-path": "url(#clip0_286_2296)",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M7.15845 13.9925L10.9751 10.1675L7.15845 6.34248L8.33345 5.16748L13.3334 10.1675L8.33345 15.1675L7.15845 13.9925Z",
                    fill: "#6B6B6B"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_286_2296",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "20",
                        height: "20",
                        fill: "white",
                        transform: "translate(0 0.16748)"
                    })
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/ProductCustomizationPopUp/components/ImageUploadSection.js


var ImageUpload = function(props) {
    var tempImages = props.tempImages, handleImageUpload = props.handleImageUpload, handleImageRemove = props.handleImageRemove, allImageMandatory = props.allImageMandatory;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "pp-image-upload tw-mt-4 tw-flex tw-flex-col tw-gap-[0.75rem]",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "tw-flex tw-gap-[0.5rem]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                        className: "tw-text-[0.875rem] tw-font-medium tw-text-[#222] md:tw-text-[1rem]",
                        children: [
                            "Images",
                            !!allImageMandatory && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "tw-ml-[2px] tw-text-[#222]",
                                children: "*"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "tw-text-[0.875rem] tw-font-normal tw-text-[#999] md:tw-text-[1rem]",
                        children: "(JPG, PNG up to 5 MB)"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "tw-relative tw-grid tw-grid-cols-4 tw-gap-3 md:tw-grid-cols-5",
                children: tempImages === null || tempImages === void 0 ? void 0 : tempImages.map(function(image, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "tw-relative",
                        children: image ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "tw-relative tw-h-[70px] tw-w-full md:tw-h-[100px] md:tw-w-[100px]",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: image,
                                    alt: "Upload ".concat(index),
                                    className: "tw-h-full tw-w-full tw-border tw-border-solid tw-border-[#0000001A] tw-object-cover"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "tw-absolute tw-right-[0.25rem] tw-top-[0.25rem] tw-flex tw-cursor-pointer tw-items-center tw-justify-center tw-rounded tw-bg-[#000000A6]",
                                    onClick: function() {
                                        return handleImageRemove(index);
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RemoveIcon, {})
                                })
                            ]
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "tw-flex tw-h-[70px] tw-w-full tw-cursor-pointer tw-items-center tw-justify-center tw-rounded tw-border tw-border-solid tw-border-[#E9E9E9] tw-bg-[#F7F7F7] md:tw-h-[100px] md:tw-w-[100px]",
                            onClick: function() {
                                return document.getElementById("upload-".concat(index)).click();
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PlusIcon, {
                                        color: "#0E0E0E"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                    type: "file",
                                    id: "upload-".concat(index),
                                    className: "tw-hidden",
                                    accept: "image/*",
                                    onChange: function(e) {
                                        return handleImageUpload(e, index);
                                    }
                                })
                            ]
                        }, index)
                    }, index);
                })
            })
        ]
    });
};
/* harmony default export */ var ImageUploadSection = (ImageUpload);

;// CONCATENATED MODULE: ./src/components/ProductCustomizationPopUp/components/TextBox.js

var TextBox = function(props) {
    var textCount = props.textCount, textData = props.textData, handleTextDataChange = props.handleTextDataChange;
    var currentTextLength = (textData === null || textData === void 0 ? void 0 : textData.length) || 0;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "pp-text-box tw-flex tw-flex-col tw-gap-[0.75rem]",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "tw-flex tw-gap-[0.5rem]",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "tw-text-[0.875rem] tw-font-medium tw-text-[#222] md:tw-text-[1rem]",
                    children: "Text"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "tw-flex tw-flex-col tw-gap-[6px]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("textarea", {
                        placeholder: "Enter custom text",
                        className: "personalization__input--textbox tw-h-[105px] tw-resize-none tw-rounded-[4px] tw-border-[#D2D2D2] tw-px-[0.75rem] tw-py-[0.625rem] tw-text-[0.875rem] tw-font-medium tw-leading-5 tw-text-[#0E0E0E] md:tw-text-[1rem]",
                        value: textData || "",
                        onChange: handleTextDataChange
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                        className: "tw-flex tw-justify-end tw-text-[0.75rem] tw-font-normal tw-text-[#6B6B6B] md:tw-text-[0.875rem]",
                        children: [
                            currentTextLength,
                            "/",
                            textCount
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var components_TextBox = (TextBox);

// EXTERNAL MODULE: ./src/components/DesignSystem/AtomicComponents/index.js + 2 modules
var AtomicComponents = __webpack_require__(38855);
// EXTERNAL MODULE: ./src/utils/getCustomCtaText.js
var getCustomCtaText = __webpack_require__(36623);
;// CONCATENATED MODULE: ./src/components/ProductCustomizationPopUp/components/RenderProductCTA.js



var RenderProductCTA = function(param) {
    var storeInfo = param.storeInfo, checkIsCtaActive = param.checkIsCtaActive, handleAddToCart = param.handleAddToCart, onBuyNowClick = param.onBuyNowClick, source = param.source;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9;
    var isCartPage = function() {
        if (true) {
            var pathname = window.location.pathname;
            return pathname.includes("/cart");
        }
        return false;
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "pp-action-cta tw-mt-[16px] tw-flex tw-justify-center tw-gap-[16px] md:tw-gap-[24px]",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AtomicComponents/* Button */.zx, {
                label: "Add to Cart",
                variant: isCartPage() ? "" : "outline",
                borderColor: storeInfo === null || storeInfo === void 0 ? void 0 : (ref = storeInfo.theme) === null || ref === void 0 ? void 0 : (ref1 = ref.colors) === null || ref1 === void 0 ? void 0 : ref1.primary_color,
                backgroundColor: storeInfo === null || storeInfo === void 0 ? void 0 : (ref2 = storeInfo.theme) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.colors) === null || ref3 === void 0 ? void 0 : ref3.primary_color,
                fontSize: "14",
                fontWeight: 500,
                px: "12px",
                py: "12px",
                width: "100%",
                roundness: (storeInfo === null || storeInfo === void 0 ? void 0 : (ref4 = storeInfo.theme) === null || ref4 === void 0 ? void 0 : ref4.roundness) || "4px",
                className: "".concat(checkIsCtaActive() ? "tw-cursor-pointer tw-opacity-100" : "tw-pointer-events-none tw-opacity-50"),
                onClick: function() {
                    return handleAddToCart("add");
                }
            }),
            !isCartPage() && /*#__PURE__*/ (0,jsx_runtime.jsx)(AtomicComponents/* Button */.zx, {
                borderColor: "#EDEDED",
                borderWidth: "0px",
                label: (storeInfo === null || storeInfo === void 0 ? void 0 : (ref5 = storeInfo.theme) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.cta_config) === null || ref6 === void 0 ? void 0 : ref6.pdp_cta) || (0,getCustomCtaText/* default */.Z)("buy_now_cta"),
                backgroundColor: storeInfo === null || storeInfo === void 0 ? void 0 : (ref7 = storeInfo.theme) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.colors) === null || ref8 === void 0 ? void 0 : ref8.primary_color,
                fontSize: "14",
                fontWeight: 500,
                px: "12px",
                py: "12px",
                width: "100%",
                roundness: (storeInfo === null || storeInfo === void 0 ? void 0 : (ref9 = storeInfo.theme) === null || ref9 === void 0 ? void 0 : ref9.roundness) || "4px",
                className: "".concat(checkIsCtaActive() ? "tw-cursor-pointer tw-opacity-100" : "tw-pointer-events-none tw-opacity-50"),
                onClick: onBuyNowClick
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./src/components/Common/Toast/index.jsx
var Toast = __webpack_require__(40804);
// EXTERNAL MODULE: ./src/components/WidgetMaker/WidgetsComponents/CommonComponents/canvasUtils.js
var canvasUtils = __webpack_require__(29616);
// EXTERNAL MODULE: ./src/redux/actions/catalog.js
var catalog = __webpack_require__(96031);
// EXTERNAL MODULE: ./src/redux/store/index.js + 43 modules
var store = __webpack_require__(80344);
// EXTERNAL MODULE: ./src/utils/itemQuantityValueComparison.js
var itemQuantityValueComparison = __webpack_require__(73175);
;// CONCATENATED MODULE: ./src/components/ProductCustomizationPopUp/utils/common.js








function readFile(file) {
    return new Promise(function(resolve) {
        var reader = new FileReader();
        reader.addEventListener("load", function() {
            return resolve(reader.result);
        }, false);
        reader.readAsDataURL(file);
    });
}
var validatePersonalization = function(images, textData, productCustomizationCount) {
    var hasNullImages = images === null || images === void 0 ? void 0 : images.some(function(image) {
        return image === null;
    });
    var noImagesUploaded = images === null || images === void 0 ? void 0 : images.every(function(image) {
        return image === null;
    });
    var validationStatus = {
        status: true,
        images: true,
        text: true
    };
    // Check if image is required and cx uploads no image
    if ((productCustomizationCount === null || productCustomizationCount === void 0 ? void 0 : productCustomizationCount.imageCount) && noImagesUploaded) {
        validationStatus.status = false;
        validationStatus.images = false;
    } else if ((productCustomizationCount === null || productCustomizationCount === void 0 ? void 0 : productCustomizationCount.imageCount) && (productCustomizationCount === null || productCustomizationCount === void 0 ? void 0 : productCustomizationCount.allImageMandatory) && hasNullImages) {
        // Check if image count is mandatory and all images must be uploaded
        validationStatus.status = false;
        validationStatus.images = false;
    }
    if ((productCustomizationCount === null || productCustomizationCount === void 0 ? void 0 : productCustomizationCount.textCount) > 0 && (textData === null || textData === void 0 ? void 0 : textData.length) === 0) {
        validationStatus.status = false;
        validationStatus.text = false;
    }
    return validationStatus;
};
var getHeadingText = function(showInitialScreen, personalizedProduct) {
    if (showInitialScreen() && (personalizedProduct === null || personalizedProduct === void 0 ? void 0 : personalizedProduct.editPersonalizationPopUp)) {
        return "Edit personalisation";
    } else if (showInitialScreen() && !(personalizedProduct === null || personalizedProduct === void 0 ? void 0 : personalizedProduct.editPersonalizationPopUp)) {
        return "Personalise this product";
    }
    return (personalizedProduct === null || personalizedProduct === void 0 ? void 0 : personalizedProduct.actionType) === "inc" ? "Repeat last used personalisation?" : "Your personalisations";
};
var filterNull = function(item, checkType) {
    var ref;
    return item === null || item === void 0 ? void 0 : (ref = item.filter) === null || ref === void 0 ? void 0 : ref.call(item, function(ele) {
        return ele !== checkType;
    });
};
var initializeState = function(personalizedProduct, imageCount) {
    var ref, ref1;
    var ref2;
    var newImages = (ref2 = personalizedProduct === null || personalizedProduct === void 0 ? void 0 : (ref = personalizedProduct.editableData) === null || ref === void 0 ? void 0 : ref.images) !== null && ref2 !== void 0 ? ref2 : Array.from({
        length: imageCount
    }, function() {
        return null;
    });
    var ref3;
    var newTextData = (ref3 = personalizedProduct === null || personalizedProduct === void 0 ? void 0 : (ref1 = personalizedProduct.editableData) === null || ref1 === void 0 ? void 0 : ref1.texts) !== null && ref3 !== void 0 ? ref3 : [
        ""
    ];
    return {
        newImages: newImages,
        newTextData: newTextData
    };
};
function blobToByteArray(blob) {
    return new Promise(function(resolve, reject) {
        var reader = new FileReader();
        // Event handler for when the Blob has been read successfully
        reader.onload = function(event) {
            var arrayBuffer = event.target.result;
            // Create a byte array from the ArrayBuffer
            var byteArray = new Uint8Array(arrayBuffer);
            resolve(byteArray);
        };
        // Event handler for errors
        reader.onerror = function(error) {
            reject(error);
        };
        // Read the Blob as an ArrayBuffer
        reader.readAsArrayBuffer(blob);
    });
}
function byteArrayToBase64(byteArray) {
    // Convert the byte array to a string
    var binary = "";
    var len = byteArray.byteLength;
    for(var i = 0; i < len; i++){
        binary += String.fromCharCode(byteArray[i]);
    }
    // Convert the binary string to a base64 encoded string
    return btoa(binary);
}
var handleImageUpload = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(e, idx, images, setImages, setErrorState, tempImages, setTempImages) {
        var ref, ref1, file, fileSizeInMB, imageDataUrl, imageType, convertImageToBlob, formData;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!(e.target.files && e.target.files.length > 0)) return [
                        3,
                        3
                    ];
                    file = e.target.files[0];
                    fileSizeInMB = file.size / (1024 * 1024);
                    if (fileSizeInMB >= 5) {
                        (0,Toast/* toastNotifyError */.Lu)("File size should be less than 5MB");
                        return [
                            2
                        ];
                    }
                    return [
                        4,
                        readFile(file)
                    ];
                case 1:
                    imageDataUrl = _state.sent();
                    imageType = (ref = imageDataUrl === null || imageDataUrl === void 0 ? void 0 : imageDataUrl.split(";")[0]) === null || ref === void 0 ? void 0 : ref.split(":")[1];
                    return [
                        4,
                        (0,canvasUtils/* resizedataURL */.YE)(imageDataUrl, 0, 0, imageType)
                    ];
                case 2:
                    convertImageToBlob = _state.sent();
                    formData = new FormData();
                    formData.append("media_type", "store_logo");
                    formData.append("store_id", (ref1 = store/* default.getState */.Z.getState().storeReducer.store) === null || ref1 === void 0 ? void 0 : ref1.store_id);
                    formData.append("media", convertImageToBlob);
                    blobToByteArray(convertImageToBlob).then(function(byteArray) {
                        var str = byteArrayToBase64(byteArray);
                        var newImages = (0,_to_consumable_array/* default */.Z)(images);
                        newImages[idx] = str;
                        setImages(newImages);
                        var newTempImages = (0,_to_consumable_array/* default */.Z)(tempImages);
                        newTempImages[idx] = imageDataUrl;
                        setTempImages(newTempImages);
                        setErrorState("");
                    }).catch(function(error) {
                        console.error("Error:", error);
                    });
                    _state.label = 3;
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return function handleImageUpload(e, idx, images, setImages, setErrorState, tempImages, setTempImages) {
        return _ref.apply(this, arguments);
    };
}();
var handleImageRemove = function(idx, images, setImages, tempImages, setTempImages) {
    var newImageList = (0,_to_consumable_array/* default */.Z)(images);
    newImageList[idx] = null;
    var newTempImageList = (0,_to_consumable_array/* default */.Z)(tempImages);
    newTempImageList[idx] = null;
    setTempImages(newTempImageList);
    setImages(newImageList);
};
var handleTextDataChange = function(e, textCount, setTextData, setErrorState) {
    var newText = e.target.value;
    // Truncate the text if it exceeds textCount
    if (newText.length > textCount) {
        newText = newText.slice(0, textCount);
    }
    setTextData([
        newText
    ]);
    setErrorState("");
};
var checkIsCtaActive = function(images, textData) {
    var ref;
    var hasNonNullImages = images.some(function(image) {
        return image !== null;
    });
    var hasTextData = ((ref = textData[0]) === null || ref === void 0 ? void 0 : ref.length) > 0;
    return hasNonNullImages || hasTextData;
};
var checkIfIncrementAllowed = function(type, productData, cartData) {
    var ref, ref1, ref2;
    var isIncrementAction = type === "add" || type === "inc";
    if (!isIncrementAction) return true;
    var hasVariants = (productData === null || productData === void 0 ? void 0 : productData.variants_count) || (productData === null || productData === void 0 ? void 0 : (ref = productData.variants) === null || ref === void 0 ? void 0 : ref.length) > 0;
    // Variants case
    if (hasVariants) {
        var ref3;
        var activeVariantId = localStorage.getItem("activeVariantId");
        var activeVariant = productData === null || productData === void 0 ? void 0 : (ref3 = productData.variants) === null || ref3 === void 0 ? void 0 : ref3.find(function(el) {
            return "".concat(el === null || el === void 0 ? void 0 : el.variant_id) === activeVariantId;
        });
        if ((0,itemQuantityValueComparison/* itemQuantityValueComparison */.i)(activeVariant)) {
            (0,Toast/* toastNotifyInfo */.lU)("No more items available for purchase");
            return false;
        }
        return true;
    }
    // Case of item with no variants
    var itemIndexInCart = cartData === null || cartData === void 0 ? void 0 : (ref1 = cartData.items) === null || ref1 === void 0 ? void 0 : ref1.findIndex(function(el) {
        return (el.id || el.item_id) === ((productData === null || productData === void 0 ? void 0 : productData.id) || (productData === null || productData === void 0 ? void 0 : productData.item_id));
    });
    var productItem = cartData === null || cartData === void 0 ? void 0 : (ref2 = cartData.items) === null || ref2 === void 0 ? void 0 : ref2[itemIndexInCart];
    if ((0,itemQuantityValueComparison/* itemQuantityValueComparison */.i)(productItem)) {
        (0,Toast/* toastNotifyInfo */.lU)("No more items available for purchase");
        return false;
    }
    return true;
};
var handleCartUpdate = function(type, data, ppIdx, handleAddPersonalizationToLocalState, images, textData, imageCount, textCount, allImageMandatory, personalizedProduct, handleCart, dispatch, productData, source, setImages, setTextData, setErrorState, cartData, scheduleInfo) {
    var ref, ref1;
    var imageData = (data === null || data === void 0 ? void 0 : data.images) || images;
    var text = (data === null || data === void 0 ? void 0 : (ref = data.texts) === null || ref === void 0 ? void 0 : ref[0]) || (textData === null || textData === void 0 ? void 0 : textData[0]);
    var ref2 = validatePersonalization(imageData, text, {
        imageCount: imageCount,
        textCount: textCount,
        allImageMandatory: allImageMandatory
    }), status = ref2.status, imageStatus = ref2.images, textStatus = ref2.text;
    if (!status) {
        if (!imageStatus && !textStatus) {
            setErrorState("Please complete all personalisation details");
        } else if (!imageStatus) {
            var errorText = allImageMandatory ? "Please upload all images." : "At least one image is required";
            setErrorState(errorText);
        } else {
            setErrorState("Please enter text for personalisation");
        }
        return;
    }
    if (!checkIfIncrementAllowed(type, productData, cartData)) {
        dispatch((0,catalog/* closeProductPersonalizationPopUp */.xS)());
        return;
    }
    var ref3;
    var productPersonalizationPayload = {
        images: (data === null || data === void 0 ? void 0 : data.images) || images.filter(function(ele) {
            return ele !== null;
        }),
        texts: (data === null || data === void 0 ? void 0 : data.texts) || textData.filter(function(ele) {
            return ele !== "";
        }),
        quantity: (ref3 = data === null || data === void 0 ? void 0 : (ref1 = data[ppIdx]) === null || ref1 === void 0 ? void 0 : ref1.quantity) !== null && ref3 !== void 0 ? ref3 : 1
    };
    if (type === "add") {
        handleAddPersonalizationToLocalState(productPersonalizationPayload);
    }
    handleCart(type, productPersonalizationPayload, ppIdx, productData, source, null, scheduleInfo);
    if (type === "save") {
        dispatch((0,catalog/* closeProductPersonalizationPopUp */.xS)());
        setImages(Array.from({
            length: imageCount
        }, function() {
            return null;
        }));
        setTextData([
            ""
        ]);
    }
};
var handleByNowClick = function(images, textData, imageCount, textCount, allImageMandatory, onBuyNowClick, setImages, setTextData, setErrorState, scheduleInfo) {
    var ref = validatePersonalization(images, textData[0], {
        imageCount: imageCount,
        textCount: textCount,
        allImageMandatory: allImageMandatory
    }), status = ref.status, imageStatus = ref.images, textStatus = ref.text;
    if (!status) {
        if (!imageStatus && !textStatus) {
            setErrorState("Please complete all personalisation details");
        } else if (!imageStatus) {
            setErrorState("Please upload all images.");
        } else {
            setErrorState("Please enter text for personalisation");
        }
        return;
    }
    var productPersonalizationPayload = {
        images: images.filter(function(ele) {
            return ele !== null;
        }),
        texts: textData.filter(function(ele) {
            return ele !== "";
        }),
        quantity: 1
    };
    onBuyNowClick(productPersonalizationPayload, scheduleInfo);
    setImages(Array.from({
        length: imageCount
    }, function() {
        return null;
    }));
    setTextData([
        ""
    ]);
};

// EXTERNAL MODULE: ./src/components/ProductCustomizationPopUp/utils/constant.js
var constant = __webpack_require__(42194);
;// CONCATENATED MODULE: ./src/components/ProductCustomizationPopUp/components/InitialInputScreen.js









var InitialInputScreen = function(param) {
    var imageCount = param.imageCount, textCount = param.textCount, images = param.images, setImages = param.setImages, tempImages = param.tempImages, setTempImages = param.setTempImages, textData = param.textData, setTextData = param.setTextData, errorState = param.errorState, setErrorState = param.setErrorState, storeInfo = param.storeInfo, personalizedProduct = param.personalizedProduct, handleCart = param.handleCart, productData = param.productData, source = param.source, allImageMandatory = param.allImageMandatory, onBuyNowClick = param.onBuyNowClick, cartData = param.cartData, handleAddPersonalizationToLocalState = param.handleAddPersonalizationToLocalState, personalizationLocalState = param.personalizationLocalState, _scheduleInfo = param.scheduleInfo, scheduleInfo = _scheduleInfo === void 0 ? null : _scheduleInfo;
    var ref, ref1;
    var dispatch = (0,es/* useDispatch */.I0)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            !!imageCount && /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageUploadSection, {
                images: images,
                tempImages: tempImages,
                allImageMandatory: allImageMandatory,
                setImages: setImages,
                handleImageUpload: function(e, idx) {
                    return handleImageUpload(e, idx, images, setImages, setErrorState, tempImages, setTempImages);
                },
                handleImageRemove: function(idx) {
                    return handleImageRemove(idx, images, setImages, tempImages, setTempImages);
                }
            }),
            !!textCount && /*#__PURE__*/ (0,jsx_runtime.jsx)(components_TextBox, {
                textCount: textCount,
                textData: textData[0],
                handleTextDataChange: function(e) {
                    return handleTextDataChange(e, textCount, setTextData, setErrorState);
                }
            }),
            errorState && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "tw-flex tw-items-center tw-gap-2",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorIcon, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "tw-text-[0.875rem] tw-font-medium tw-text-[#9A0C00]",
                        children: errorState
                    })
                ]
            }),
            (personalizedProduct === null || personalizedProduct === void 0 ? void 0 : personalizedProduct.editPersonalizationPopUp) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                className: "tw-flex tw-w-full tw-cursor-pointer tw-items-center tw-justify-center tw-rounded tw-border-none tw-bg-black tw-py-[0.75rem] tw-text-[0.875rem] tw-font-medium tw-text-[#fff]",
                style: {
                    backgroundColor: (storeInfo === null || storeInfo === void 0 ? void 0 : (ref = storeInfo.theme) === null || ref === void 0 ? void 0 : (ref1 = ref.colors) === null || ref1 === void 0 ? void 0 : ref1.primary_color) || "black"
                },
                onClick: function() {
                    var ref;
                    return handleCartUpdate(constant/* OPERATION_TYPE.SAVE */.f.SAVE, personalizationLocalState, personalizedProduct === null || personalizedProduct === void 0 ? void 0 : (ref = personalizedProduct.personalizationData) === null || ref === void 0 ? void 0 : ref.index, null, images, textData, imageCount, textCount, allImageMandatory, personalizedProduct, handleCart, dispatch, productData, source, setImages, setTextData, setErrorState, cartData);
                },
                children: "Save Changes"
            }) : (!!imageCount || !!textCount) && /*#__PURE__*/ (0,jsx_runtime.jsx)(RenderProductCTA, {
                storeInfo: storeInfo,
                checkIsCtaActive: function() {
                    return checkIsCtaActive(images, textData);
                },
                handleAddToCart: function() {
                    return handleCartUpdate("add", personalizationLocalState, null, handleAddPersonalizationToLocalState, images, textData, imageCount, textCount, allImageMandatory, personalizedProduct, handleCart, dispatch, productData, source, setImages, setTextData, setErrorState, cartData, scheduleInfo);
                },
                onBuyNowClick: function() {
                    return handleByNowClick(images, textData, imageCount, textCount, allImageMandatory, onBuyNowClick, setImages, setTextData, setErrorState, scheduleInfo);
                },
                source: source
            })
        ]
    });
};
/* harmony default export */ var components_InitialInputScreen = (InitialInputScreen);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./src/components/ProductCustomizationPopUp/components/ReadMoreReadLess.js
var ReadMoreReadLess = __webpack_require__(19976);
// EXTERNAL MODULE: ./src/utils/checkRenderEnv.js
var checkRenderEnv = __webpack_require__(6337);
// EXTERNAL MODULE: ./src/redux/index.ts
var redux = __webpack_require__(68037);
// EXTERNAL MODULE: ./src/components/DesignSystem/AtomicComponents/CartButton/CartItemInput.tsx
var CartItemInput = __webpack_require__(98221);
;// CONCATENATED MODULE: ./src/components/ProductCustomizationPopUp/components/IncrementProductPersonalizationScreen.js













var IncrementProductPersonalizationScreen = function(param) {
    var cartData = param.cartData, personalizedProduct = param.personalizedProduct, setImages = param.setImages, setTempImages = param.setTempImages, setTextData = param.setTextData, imageCount = param.imageCount, handleCart = param.handleCart, productData = param.productData, source = param.source, personalizationLocalState = param.personalizationLocalState, setPersonalizationLocalState = param.setPersonalizationLocalState, storeData = param.storeData;
    var getPersonalizationTotalQuantity = function getPersonalizationTotalQuantity(newState) {
        var ref;
        return (ref = newState || personalizationLocalState) === null || ref === void 0 ? void 0 : ref.reduce(function(sum, item) {
            return sum + (item.quantity || 0);
        }, 0);
    };
    var addNewPersonalization = function addNewPersonalization() {
        if (!allowItemAddition()) {
            (0,Toast/* toastNotifyInfo */.lU)("Unable to add new personalization as item limits exceeded");
            return;
        }
        dispatch((0,catalog/* openProductPersonalizationPopUp */.w4)());
    };
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8;
    var dispatch = (0,es/* useDispatch */.I0)();
    var storeInfo = (0,redux/* useSSRSelector */.kF)(function(state) {
        return state.storeReducer.store;
    });
    var ref9 = (0,react.useState)(false), showConfirmCTA = ref9[0], setShowConfirmCTA = ref9[1];
    var isEditable = !!(storeInfo === null || storeInfo === void 0 ? void 0 : (ref = storeInfo.services) === null || ref === void 0 ? void 0 : ref.custom_cart_item_quantity_flag);
    var handleEditPersonalization = function(param) {
        var _data = param.data, data = _data === void 0 ? {} : _data, _personalizedProductData = param.personalizedProductData, personalizedProductData = _personalizedProductData === void 0 ? {} : _personalizedProductData, _idx = param.idx, idx = _idx === void 0 ? null : _idx;
        var filledImages = new Array(imageCount).fill(null).map(function(_, i) {
            return (data === null || data === void 0 ? void 0 : data.images[i]) || null;
        });
        setImages(filledImages);
        setTempImages(filledImages);
        setTextData(data === null || data === void 0 ? void 0 : data.texts);
        dispatch((0,catalog/* editProductPersonalization */.Ux)({
            personalizedProductData: personalizedProductData ? (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, personalizedProductData), {
                index: idx
            }) : {}
        }));
    };
    var allowItemAddition = function() {
        var newState = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
        var ref, ref1;
        var itemIndexInCart = cartData === null || cartData === void 0 ? void 0 : (ref = cartData.items) === null || ref === void 0 ? void 0 : ref.findIndex(function(el) {
            return ((el === null || el === void 0 ? void 0 : el.id) || (el === null || el === void 0 ? void 0 : el.item_id)) === ((productData === null || productData === void 0 ? void 0 : productData.id) || (productData === null || productData === void 0 ? void 0 : productData.item_id));
        });
        var productItem = (cartData === null || cartData === void 0 ? void 0 : cartData.items) && cartData.items[itemIndexInCart] || null;
        var totalQuantity = getPersonalizationTotalQuantity(newState);
        if ((productItem === null || productItem === void 0 ? void 0 : productItem.variants_count) || !!(productItem === null || productItem === void 0 ? void 0 : (ref1 = productItem.variants_selected) === null || ref1 === void 0 ? void 0 : ref1.length)) {
            var variantsPresentInCart = (productItem === null || productItem === void 0 ? void 0 : productItem.variants_selected) || [];
            var activeVariantId = checkRenderEnv/* IS_CLIENT */.kc && localStorage.getItem("activeVariantId");
            var activeVariant = variantsPresentInCart === null || variantsPresentInCart === void 0 ? void 0 : variantsPresentInCart.find(function(variant) {
                return "".concat(variant === null || variant === void 0 ? void 0 : variant.variant_id) === activeVariantId;
            });
            if (activeVariant === null || activeVariant === void 0 ? void 0 : activeVariant.managed_inventory) {
                return totalQuantity < (activeVariant === null || activeVariant === void 0 ? void 0 : activeVariant.available_quantity);
            }
        } else {
            if ((productItem === null || productItem === void 0 ? void 0 : productItem.managed_inventory) && totalQuantity >= (productItem === null || productItem === void 0 ? void 0 : productItem.available_quantity)) {
                return false;
            }
        }
        return true;
    };
    var updateLocalQuantity = function(idx, type) {
        var count = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
        setPersonalizationLocalState(function(prevState) {
            var newState = (0,_to_consumable_array/* default */.Z)(prevState);
            var item = (0,_object_spread/* default */.Z)({}, newState[idx]);
            if (type === "inc") {
                if (allowItemAddition()) {
                    item.quantity = (item.quantity || 0) + 1;
                    setShowConfirmCTA(true);
                } else {
                    (0,Toast/* toastNotifyInfo */.lU)("No more units available for purchase");
                }
            } else if (type === "dec") {
                item.quantity = Math.max((item.quantity || 0) - 1, 0);
                setShowConfirmCTA(true);
            } else if (type === "custom") {
                var currentQuantity = item.quantity;
                item.quantity = count;
                newState[idx] = item;
                if (allowItemAddition(newState)) {
                    setShowConfirmCTA(true);
                } else {
                    item.quantity = currentQuantity;
                }
            }
            newState[idx] = item;
            return newState;
        });
    };
    var handleConfirmChanges = function() {
        handleCart("confirm", null, null, productData, source, personalizationLocalState);
        dispatch((0,catalog/* closeProductPersonalizationPopUp */.xS)());
        setShowConfirmCTA(false);
        setPersonalizationLocalState([]);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "tw-flex tw-flex-col tw-gap-[1.5rem] tw-rounded-lg tw-shadow-[2px_2px_8px_0px_#0000000a]",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: " tw-flex tw-flex-col tw-rounded-[8px] tw-bg-[#fff] tw-pb-[1.25rem]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "tw-flex-tw-flex-col",
                        children: personalizationLocalState === null || personalizationLocalState === void 0 ? void 0 : personalizationLocalState.map(function(data, idx) {
                            var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7;
                            var text = data === null || data === void 0 ? void 0 : (ref = data.texts) === null || ref === void 0 ? void 0 : ref[0];
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "tw-flex tw-gap-[1.5rem] tw-border-b tw-border-solid tw-border-[#d9d9d9] tw-pb-[1.125rem] tw-pt-[1.25rem]",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "tw-flex tw-w-[75%] tw-flex-col tw-gap-[0.5rem] tw-pl-[1rem] md:tw-gap-[0.75rem]",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "tw-text-[0.75rem] tw-font-semibold tw-leading-5 tw-text-[#0E0E0E] md:tw-text-[14px]",
                                                children: personalizedProduct === null || personalizedProduct === void 0 ? void 0 : (ref1 = personalizedProduct.personalizationData) === null || ref1 === void 0 ? void 0 : ref1.item_name
                                            }),
                                            !!(data === null || data === void 0 ? void 0 : (ref2 = data.images) === null || ref2 === void 0 ? void 0 : ref2.length) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "tw-flex tw-flex-wrap tw-gap-[0.75rem]",
                                                children: data === null || data === void 0 ? void 0 : (ref3 = data.images) === null || ref3 === void 0 ? void 0 : ref3.map(function(imageDataUrl, idx) {
                                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                        src: imageDataUrl,
                                                        alt: "product-image",
                                                        width: "46px",
                                                        height: "48px",
                                                        className: "tw-rounded tw-border tw-border-solid tw-border-[#0000001A]"
                                                    }, idx);
                                                })
                                            }),
                                            !!(text === null || text === void 0 ? void 0 : text.length) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ReadMoreReadLess/* default */.Z, {
                                                    text: text,
                                                    color: "#4E4E4E"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "tw-flex tw-items-center",
                                                onClick: function() {
                                                    return handleEditPersonalization({
                                                        data: data,
                                                        personalizedProductData: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, personalizedProduct === null || personalizedProduct === void 0 ? void 0 : personalizedProduct.personalizationData), {
                                                            quantity: data === null || data === void 0 ? void 0 : data.quantity
                                                        }),
                                                        idx: idx
                                                    });
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "tw-flex tw-cursor-pointer tw-items-center tw-text-[0.875rem] tw-font-semibold tw-text-[#4E4E4E]",
                                                        children: "Edit personalisation"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "tw-flex tw-items-center tw-pt-[2px]",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RightArrowIcon, {})
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "tw-fl-col tw-flex tw-w-[25%] tw-flex-col tw-gap-[1.125rem] tw-pr-[1rem]",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "tw-flex ".concat(isEditable ? "tw-w-[120px]" : "tw-w-[92px]", " tw-items-center tw-justify-between tw-gap-[0.625rem] tw-self-end tw-rounded tw-border tw-border-solid tw-border-[#000] tw-p-[0.5rem] tw-text-[0.875rem] tw-font-normal"),
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "tw-flex tw-cursor-pointer tw-items-center tw-justify-center",
                                                        onClick: function() {
                                                            return updateLocalQuantity(idx, "dec");
                                                        },
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CartMinusIcon, {})
                                                    }),
                                                    isEditable ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CartItemInput/* default */.Z, {
                                                        value: personalizationLocalState === null || personalizationLocalState === void 0 ? void 0 : (ref4 = personalizationLocalState[idx]) === null || ref4 === void 0 ? void 0 : ref4.quantity,
                                                        onChange: function(value) {
                                                            return updateLocalQuantity(idx, "custom", value || 1);
                                                        }
                                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: personalizationLocalState === null || personalizationLocalState === void 0 ? void 0 : (ref5 = personalizationLocalState[idx]) === null || ref5 === void 0 ? void 0 : ref5.quantity
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "tw-flex tw-cursor-pointer tw-items-center tw-justify-center",
                                                        onClick: function() {
                                                            return updateLocalQuantity(idx, "inc");
                                                        },
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CartPlusIcon, {
                                                            color: allowItemAddition() ? "#0E0E0E" : "#ccc"
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                className: "tw-self-end tw-text-[0.875rem] tw-font-normal tw-leading-5",
                                                children: [
                                                    "₹",
                                                    (personalizedProduct === null || personalizedProduct === void 0 ? void 0 : (ref6 = personalizedProduct.personalizationData) === null || ref6 === void 0 ? void 0 : ref6.discounted_price) * (personalizationLocalState === null || personalizationLocalState === void 0 ? void 0 : (ref7 = personalizationLocalState[idx]) === null || ref7 === void 0 ? void 0 : ref7.quantity)
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }, idx);
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "tw-mt-[1.125rem] tw-flex tw-items-center tw-justify-center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                            className: "tw-flex tw-cursor-pointer tw-items-center tw-justify-center tw-gap-[0.5rem]",
                            onClick: addNewPersonalization,
                            style: !allowItemAddition() ? {
                                opacity: 0.3,
                                color: (storeData === null || storeData === void 0 ? void 0 : (ref1 = storeData.theme) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.colors) === null || ref2 === void 0 ? void 0 : ref2.primary_color) || "#1F1F1F"
                            } : {
                                color: (storeData === null || storeData === void 0 ? void 0 : (ref3 = storeData.theme) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.colors) === null || ref4 === void 0 ? void 0 : ref4.primary_color) || "#1F1F1F"
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(PlusIcon, {
                                    color: (storeData === null || storeData === void 0 ? void 0 : (ref5 = storeData.theme) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.colors) === null || ref6 === void 0 ? void 0 : ref6.primary_color) || "#000"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "tw-text-[0.875rem] tw-font-semibold",
                                    children: "Add a new personalisation"
                                })
                            ]
                        })
                    })
                ]
            }),
            showConfirmCTA && /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                className: "tw-flex tw-w-full tw-cursor-pointer tw-items-center tw-justify-center tw-rounded tw-border-none tw-bg-black tw-py-[0.75rem] tw-text-[0.875rem] tw-font-medium tw-text-[#fff]",
                onClick: handleConfirmChanges,
                style: {
                    backgroundColor: (storeData === null || storeData === void 0 ? void 0 : (ref7 = storeData.theme) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.colors) === null || ref8 === void 0 ? void 0 : ref8.primary_color) || "black"
                },
                children: "Confirm"
            })
        ]
    });
};
/* harmony default export */ var components_IncrementProductPersonalizationScreen = (IncrementProductPersonalizationScreen);

// EXTERNAL MODULE: ./src/hooks/useCartHandler.js
var useCartHandler = __webpack_require__(91240);
;// CONCATENATED MODULE: ./src/components/ProductCustomizationPopUp/index.js












var ProductCustomizationPopUp = function(props) {
    var ref, ref1;
    var _scheduleInfoFromProps = props.scheduleInfoFromProps, scheduleInfoFromProps = _scheduleInfoFromProps === void 0 ? null : _scheduleInfoFromProps;
    var dispatch = (0,es/* useDispatch */.I0)();
    var ref2 = (0,es/* useSelector */.v9)(function(state) {
        var ref, ref1, ref2, ref3, ref4;
        return {
            productData: (ref = state.catalogReducer) === null || ref === void 0 ? void 0 : (ref1 = ref.personalizedProduct) === null || ref1 === void 0 ? void 0 : ref1.productData,
            productCustomizationCount: (ref2 = state.catalogReducer) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.personalizedProduct) === null || ref3 === void 0 ? void 0 : ref3.productCustomizationCount,
            personalizedProduct: (ref4 = state.catalogReducer) === null || ref4 === void 0 ? void 0 : ref4.personalizedProduct,
            storeInfo: state.storeReducer.store,
            cartData: state.cartReducer,
            scheduleInfo: state.commonReducer.scheduleInfo
        };
    }), productData = ref2.productData, productCustomizationCount = ref2.productCustomizationCount, personalizedProduct = ref2.personalizedProduct, storeInfo = ref2.storeInfo, cartData = ref2.cartData, scheduleInfo = ref2.scheduleInfo;
    var ref3 = productCustomizationCount || {}, _imageCount = ref3.imageCount, imageCount = _imageCount === void 0 ? 0 : _imageCount, _textCount = ref3.textCount, textCount = _textCount === void 0 ? 0 : _textCount, _allImageMandatory = ref3.allImageMandatory, allImageMandatory = _allImageMandatory === void 0 ? false : _allImageMandatory;
    var ref4 = (0,react.useState)(Array.from({
        length: imageCount
    }, function() {
        return null;
    })), images = ref4[0], setImages = ref4[1];
    var ref5 = (0,react.useState)(Array.from({
        length: imageCount
    }, function() {
        return null;
    })), tempImages = ref5[0], setTempImages = ref5[1];
    var ref6 = (0,react.useState)([
        ""
    ]), textData = ref6[0], setTextData = ref6[1]; // Initialize as an array with one empty string
    var ref7 = (0,react.useState)(""), errorState = ref7[0], setErrorState = ref7[1];
    var ref8;
    // Usecase : To keep track of updated quantity and personalisations in popup, before user clicks on confirm changes.
    var ref9 = (0,react.useState)((ref8 = personalizedProduct === null || personalizedProduct === void 0 ? void 0 : (ref = personalizedProduct.personalizationData) === null || ref === void 0 ? void 0 : (ref1 = ref.personalization_info) === null || ref1 === void 0 ? void 0 : ref1.personalizations) !== null && ref8 !== void 0 ? ref8 : []), personalizationLocalState = ref9[0], setPersonalizationLocalState = ref9[1];
    var ref10 = (0,react.useState)(productData), product = ref10[0], setProduct = ref10[1];
    var ref11 = (0,useCartHandler/* useCartHandlers */.u)(), handleCart = ref11.handleCart, onBuyNowClick = ref11.onBuyNowClick;
    (0,react.useEffect)(function() {
        var ref;
        var ref1;
        var newTextData = (ref1 = personalizedProduct === null || personalizedProduct === void 0 ? void 0 : (ref = personalizedProduct.editableData) === null || ref === void 0 ? void 0 : ref.texts) !== null && ref1 !== void 0 ? ref1 : [
            ""
        ];
        var filledImages = new Array(imageCount).fill(null).map(function(_, i) {
            var ref, ref1;
            return (personalizedProduct === null || personalizedProduct === void 0 ? void 0 : (ref = personalizedProduct.editableData) === null || ref === void 0 ? void 0 : (ref1 = ref.images) === null || ref1 === void 0 ? void 0 : ref1[i]) || null;
        });
        setImages(filledImages);
        setTempImages(filledImages);
        setTextData(newTextData);
        setProduct(productData);
    }, [
        personalizedProduct === null || personalizedProduct === void 0 ? void 0 : personalizedProduct.editableData,
        productData,
        personalizedProduct === null || personalizedProduct === void 0 ? void 0 : personalizedProduct.personalizationPopUp, 
    ]);
    (0,react.useEffect)(function() {
        setPersonalizationLocalState(function() {
            var ref, ref1;
            return (personalizedProduct === null || personalizedProduct === void 0 ? void 0 : (ref = personalizedProduct.personalizationData) === null || ref === void 0 ? void 0 : (ref1 = ref.personalization_info) === null || ref1 === void 0 ? void 0 : ref1.personalizations) || [];
        });
    }, [
        personalizedProduct === null || personalizedProduct === void 0 ? void 0 : personalizedProduct.personalizationData
    ]);
    var handleModalClose = function() {
        checkRenderEnv/* IS_CLIENT */.kc && localStorage.removeItem("activeVariantId");
        dispatch((0,catalog/* closeProductPersonalizationPopUp */.xS)());
    };
    var showInitialScreen = function() {
        return personalizedProduct === null || personalizedProduct === void 0 ? void 0 : personalizedProduct.showInitialInputScreen;
    };
    var handleAddPersonalizationToLocalState = function(data) {
        setPersonalizationLocalState(function(prevLocalState) {
            return (0,_to_consumable_array/* default */.Z)(prevLocalState).concat([
                data
            ]);
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default */.Z, {
        visible: personalizedProduct === null || personalizedProduct === void 0 ? void 0 : personalizedProduct.personalizationPopUp,
        className: "bottom-modal !tw-z-[999] ".concat(showInitialScreen() ? "product-customization-modal-initial " : "product-customization-modal-card "),
        animation: "slideUp",
        onClose: handleModalClose,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "tw-h-full tw-w-full md:tw-px-[0.75rem] md:tw-py-[0.75rem]",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "tw-relative tw-flex tw-flex-col ".concat(showInitialScreen() ? "tw-gap-[2rem]" : "tw-gap-[1.5rem]", " "),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "tw-m-[0px] tw-text-[1rem] tw-font-bold tw-text-[#000] md:tw-text-[1.5rem]",
                        children: getHeadingText(showInitialScreen, personalizedProduct)
                    }),
                    showInitialScreen() ? /*#__PURE__*/ (0,jsx_runtime.jsx)(components_InitialInputScreen, {
                        imageCount: imageCount,
                        textCount: textCount,
                        images: images,
                        tempImages: tempImages,
                        setTempImages: setTempImages,
                        setImages: setImages,
                        textData: textData,
                        setTextData: setTextData,
                        errorState: errorState,
                        setErrorState: setErrorState,
                        storeInfo: storeInfo,
                        personalizedProduct: personalizedProduct,
                        handleCart: handleCart,
                        productData: product,
                        source: "",
                        allImageMandatory: allImageMandatory,
                        onBuyNowClick: onBuyNowClick,
                        cartData: cartData,
                        handleAddPersonalizationToLocalState: handleAddPersonalizationToLocalState,
                        personalizationLocalState: personalizationLocalState,
                        scheduleInfo: scheduleInfoFromProps || scheduleInfo
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(components_IncrementProductPersonalizationScreen, {
                        personalizedProduct: personalizedProduct,
                        storeData: storeInfo,
                        cartData: cartData,
                        setImages: setImages,
                        setTempImages: setTempImages,
                        setTextData: setTextData,
                        imageCount: imageCount,
                        handleCart: handleCart,
                        productData: product,
                        source: "",
                        personalizationLocalState: personalizationLocalState,
                        setPersonalizationLocalState: setPersonalizationLocalState
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "tw-absolute tw-right-[-8px] tw-top-[-0.7rem] tw-cursor-pointer md:tw-right-[-16px] md:tw-top-[-1rem]",
                        onClick: handleModalClose,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CancelIcon, {})
                    })
                ]
            })
        })
    });
};


/***/ }),

/***/ 42194:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "d": function() { return /* binding */ READ_MORE_TEXT_LIMIT; },
/* harmony export */   "f": function() { return /* binding */ OPERATION_TYPE; }
/* harmony export */ });
var READ_MORE_TEXT_LIMIT = 50;
var OPERATION_TYPE = {
    ADD: "add",
    INC: "inc",
    DEC: "dec",
    SAVE: "save"
};


/***/ }),

/***/ 60227:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "y": function() { return /* binding */ OrderContext; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

var OrderContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)({});


/***/ }),

/***/ 73175:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "i": function() { return /* binding */ itemQuantityValueComparison; }
/* harmony export */ });
/**
 * function to check if managed inventory is allowed
 * quantity and available_quantity comparison
 * @param {*} stockItem
 * @return {boolean} boolean
 */ var itemQuantityValueComparison = function(stockItem) {
    if (!((stockItem === null || stockItem === void 0 ? void 0 : stockItem.managed_inventory) && (stockItem === null || stockItem === void 0 ? void 0 : stockItem.available_quantity) && (stockItem === null || stockItem === void 0 ? void 0 : stockItem.quantity))) {
        return false;
    }
    return stockItem.quantity >= stockItem.available_quantity;
};


/***/ })

}]);